import React, { lazy } from "react";
import Page from "components/Page";
import { Props } from "./ApprovedGuarantees";

const ApprovedGuarantees = lazy(() => import("./ApprovedGuarantees"));

export default (props: Props) => (
  <Page>
    <ApprovedGuarantees {...props} />
  </Page>
);
